import { useEffect, useState } from "react";
import publicApi from "@/lib/publicApi";

/**
 * Fetches non-secret runtime config from the backend.
 * Cached in module memory for ~60 s to avoid hammering the API.
 */
let _cache = null;
let _cacheTs = 0;
const TTL_MS = 60 * 1000;

/**
 * Drops the module-level cache so the next mount fetches fresh config.
 * Call after admin saves settings that affect public surfaces (maintenance
 * mode, GA4 ID, hCaptcha site key, business contact fields).
 */
export function invalidateSiteConfig() {
  _cache = null;
  _cacheTs = 0;
}

export default function useSiteConfig() {
  const [config, setConfig] = useState(_cache || {});
  useEffect(() => {
    const fresh = _cache && Date.now() - _cacheTs < TTL_MS;
    if (fresh) {
      setConfig(_cache);
      return;
    }
    publicApi
      .get("/public/site-config")
      .then((r) => {
        _cache = r.data || {};
        _cacheTs = Date.now();
        setConfig(_cache);
      })
      .catch(() => {
        // Silently fall back to empty config
      });
  }, []);
  return config;
}
